import OPE from 'js/on-page-editing';

import Link from 'components/link/Link';

import { IContactInfo, ILink } from 'source/NFR.types';

const getDetailType = (details: ILink[]) => {
  return {
    regText: details
      .filter(x => !x.hasOwnProperty('url'))
      .map(elem => <Link key={elem.id} {...elem} noHoverEffect={false} />),
    links: details
      .filter(x => x.hasOwnProperty('url'))
      .map(elem => <Link key={elem.id} {...elem} noHoverEffect={false} />)
  };
};

const ContactInfo: React.FC<IContactInfo> = ({ details = [], onPageEditing, title }) => (
  <div className="contact-info">
    <h3 {...OPE(onPageEditing?.title)}>{title}</h3>
    {getDetailType(details).regText.length > 0 && (
      <ul className="reg-text-details">
        <li>{getDetailType(details).regText}</li>
      </ul>
    )}
    {getDetailType(details).links.length > 0 && (
      <ul className="link-details">
        <li className="link-details--items">{getDetailType(details).links}</li>
      </ul>
    )}
  </div>
);

ContactInfo.displayName = 'ContactInfo';

export default ContactInfo;
